// extracted by mini-css-extract-plugin
module.exports = {"button":"ActionWidget_button__2Ikjs","linkButtonDisabled":"ActionWidget_linkButtonDisabled__3oDd0"};